export default __webpack_public_path__ + "static/media/favIcons-landing.19382735.svg";